enum CheckboxStateEnum {
  CHECKED = "CHECKED",
  UNCHECKED = "UNCHECKED",
  INDETERMINATE = "INDETERMINATE"
}

export default CheckboxStateEnum;
